import { render, staticRenderFns } from "./AddInterviewerToWorkspace.vue?vue&type=template&id=6525b8d8&"
import script from "./AddInterviewerToWorkspace.vue?vue&type=script&lang=js&"
export * from "./AddInterviewerToWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports